import React from 'react'
import { LabelProps, LabelSizeType } from './Label.types'
import { StyledLabel } from './styled'
import Flex from '../Flex'
import Text from '../Text'
import LabelNotification from './LabelNotification'

const labelTextSize: LabelSizeType = {
  regular: 'caption',
  small: 'small',
}

const Label: React.FC<LabelProps> = ({
  variant = 'neutral',
  size = 'small',
  children,
  preffix,
  ...restProps
}) => (
  <StyledLabel
    variant={variant}
    size={size}
    width='fit-content'
    padding='1px 8px'
    borderRadius='100px'
    {...restProps}
  >
    <Flex as='span' alignItems='center' columnGap='4px'>
      {preffix}
      <Text variant={labelTextSize[size]} weight='bold'>
        {children}
      </Text>
    </Flex>
  </StyledLabel>
)

export default Object.assign(Label, {
  Notification: LabelNotification,
})
